<template>
  <Pull :onPull="pull" ref="pull">
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>工单列表</span>
    </div>
    <!-- 顶部状态菜单选择部分 -->
    <div class="menu-select">
      <div @click="dateShow = true">
        <span>选择日期</span>
        <a-icon type="down" :style="{ fontSize: '12px' }" />
      </div>
      <div @click="roomShow = true">
        <span>{{ selectRoomName }}</span>
        <a-icon type="down" />
      </div>
      <div @click="tableShow = true">
        <span>{{ selectTableName }}</span>
        <a-icon type="down" :style="{ fontSize: '12px' }" />
      </div>
      <div @click="statusShow = true">
        <span>{{ selectStatusName }}</span>
        <a-icon type="down" :style="{ fontSize: '12px' }" />
      </div>
    </div>
    <!-- 抄表进度部分 -->
    <div class="copy-process">
      <span>处理进度</span>
      <a-progress :percent="progressData.percent" :show-info="false" />
      <div>
        <span>{{progressData.finished}}/</span>
        <span>{{progressData.total}}</span>
      </div>
    </div>
    <!-- 抄表内容部分 -->
    <div class="list-content" v-if="resdata.length > 0">
      <div class="content-all">
        <!--<div class="content-part" @click="navigatePage(item)" v-for="(item,index) in dataObj.record" :key="index">
					<img :src="item.img" mode="" />
					<div>
						<div>
							<span>{{item.instrumentationName}}</span>
							<span :style="{color:item.isMeterReading==0?'#46CC5E':'#FE5208'}">{{item.isMeterReading==0?'已抄表':'未抄表'}}</span>
						</div>
						<span>{{item.area}}</span>
						<span>上次抄表时间：{{item.lastDate}}</span>
					</div>
				</div>-->
        <div
          class="content-part"
          @click="navigatePage(item)"
          v-for="(item, index) in resdata"
          :key="index"
        >
          <img :src="item.img" mode="" />
          <div>
            <div>
              <span>{{ item.roomLocation }}</span>
              <span
                :style="{
                  color:
                    item.repairStatus == 2
                      ? '#FFBA18'
                      : item.repairStatus == 3
                      ? '#46CC5E'
                      : '#808080',
                  'background-color':
                    item.repairStatus == 2
                      ? '#FFEEC4'
                      : item.repairStatus == 3
                      ? '#D5FCCC'
                      : '#F3F3F3',
                }"
                >{{
                  item.repairStatus == 1
                    ? "待分配"
                    : item.repairStatus == 2
                    ? "处理中"
                    : item.repairStatus == 3
                    ? "已处理"
                    : item.repairStatus == 4
                    ? "已撤回"
                    : "已关闭"
                }}</span
              >
            </div>
            <span>工单内容:{{ item.repairContent }}</span>
            <span>创建时间：{{ item.createDateStr }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <img src="../assets/propertyImg/no-data.png" alt="" />
      <span>暂无房屋数据列表</span>
    </div>
    <!-- <div class="loadMore" v-if="isData" @click="gainMore">
      加载更多
    </div> -->
    <!-- 提交工单部分 -->
    <div class="contact-method" v-if="currentPermission.rwAccessStatus==2">
      <a-button
        type="primary"
        style="background: #1584FF;box-shadow: 0px 2px 8px 0px #80BCFF;border-radius: 8px;width: 90%;height: 44px;margin: 0 auto;"
        @click="showSubmit"
      >
        提交工单
      </a-button>
    </div>
    <!-- 日历选择 -->
    <van-action-sheet v-model="dateShow">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="dateShow = false"
        @confirm="dateConfirm"
        :formatter="formatter"
      />
    </van-action-sheet>
    <!-- 房屋选择 -->
    <van-popup v-model="roomShow" round position="bottom">
      <van-cascader
        title="请选择所属房屋"
        :options="areaData"
        :field-names="fieldNames"
        @close="roomShow = false"
        @finish="onListFinish"
      />
    </van-popup>
    <!-- 工单类型选择 -->
    <van-action-sheet v-model="tableShow">
      <van-picker
        title="工单类型"
        show-toolbar
        value-key="name"
        :columns="tableActions"
        @confirm="tableSelect"
        @cancel="tableShow = false"
      />
    </van-action-sheet>
    <!-- 工单状态选择 -->
    <van-action-sheet v-model="statusShow">
      <van-picker
        title="工单状态"
        show-toolbar
        value-key="name"
        :columns="statusActions"
        @confirm="statusSelect"
        @cancel="statusShow = false"
      />
    </van-action-sheet>
    <!-- 表单工单类型选择 -->
    <van-action-sheet v-model="typeFormShow">
      <van-picker
        title="工单状态"
        show-toolbar
        value-key="name"
        :columns="tableFormActions"
        @confirm="typeFormSelect"
        @cancel="typeFormShow = false"
      />
    </van-action-sheet>
    <!-- 表单所属房屋选择 -->
    <van-popup v-model="roomFormShow" round position="bottom">
      <van-cascader
        title="请选择所属房屋"
        :options="areaData"
        :field-names="fieldNames"
        @close="roomFormShow = false"
        @finish="onFinish"
      />
    </van-popup>
    <!-- 提交工单弹窗 -->
    <van-popup v-model="orderSubmit" position="bottom">
      <div>
        <div class="order-title">
          提交工单
        </div>
        <div class="order-form">
          <a-form-model ref="ruleForm" :model="form" :rules="rules">
            <a-form-model-item
              ref="repairType"
              label="工单类型"
              prop="repairType"
              style="display:flex;align-items:center;border-bottom: 1px solid #F3F3F3;padding:0.2rem 0;margin-bottom: 0.4rem;"
            >
              <div @click="typeFormShow = true" class="typeSelect">
                <span>{{ formText.typeText }}</span>
                <a-icon type="down" style="" />
              </div>
            </a-form-model-item>
            <a-form-model-item
              ref="roomId"
              label="所属房屋"
              prop="roomId"
              style="display:flex;align-items:center;border-bottom: 1px solid #F3F3F3;padding:0.2rem 0;margin-bottom: 0.4rem;"
            >
              <div @click="roomFormShow = true" class="typeSelect">
                <span>{{ formText.roomText }}</span>
                <a-icon type="down" style="" />
              </div>
            </a-form-model-item>
            <a-form-model-item
              ref="repairContent"
              label="工单内容"
              prop="repairContent"
              style="margin-bottom: 0.4rem;"
            >
              <a-textarea
                v-model="form.repairContent"
                placeholder="请输入工单内容"
                :auto-size="{ minRows: 3, maxRows: 5 }"
                style="margin-top: 0.3rem;width: 97%;"
              />
            </a-form-model-item>
            <a-form-model-item label="上传图片">
              <van-uploader
                v-model="fileList"
                multiple
                style="margin-top: 0.3rem;border-radius: 4px;"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <!-- 确认/取消部分 -->
        <div class="btn-method">
          <a-button
            style="border-radius: 8px;margin-right:0.7rem;"
            @click="orderSubmit = false"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            style="border-radius: 8px;"
            @click="confirmForm"
          >
            确定
          </a-button>
        </div>
      </div>
    </van-popup>
  </div>
  </Pull>
</template>
<script>
import { orderList, areaList, addOrder, imgUpload, orderProgress } from "../axios/property";
import { Notify } from 'vant';
import Pull from '../commonComponents/PullRefresh'
export default {
  components: {
    Pull
  },
  data() {
    return {
      dataObj: {}, // 页面总数据
      requestData: {
        // 请求数据
        createDate: "",
        roomId: "",
        repairType: null,
        repairStatus: null,
      },
      resdata: [],
      selectRoomName: "所属房屋", // 房屋种类名称
      selectTableName: "工单类型", // 仪表种类名称
      selectStatusName: "工单状态", // 仪表状态名称
      roomActions: [
        // 房屋类型
        { name: "房间", value: 1 },
        { name: "楼层", value: 2 },
        { name: "楼栋", value: 3 },
        { name: "区域", value: 4 },
      ],
      tableActions: [
        // 工单类型
        { name: "全部", value: null },
        { name: "保修", value: 1 },
        { name: "客诉", value: 2 },
      ],
      tableFormActions: [
        // 表当工单类型
        { name: "保修", value: 1 },
        { name: "客诉", value: 2 },
      ],
      statusActions: [
        // 仪表状态
        { name: "全部", value: null },
        { name: "待分配", value: 1 },
        { name: "处理中", value: 2 },
        { name: "已处理", value: 3 },
        { name: "已撤回", value: 4 },
        { name: "已关闭", value: 5 },
      ],
      dateShow: false, // 日期选择
      roomShow: false, // 所属房屋选择
      tableShow: false, // 工单类型选择
      statusShow: false, // 工单状态选择
      typeFormShow: false, // 表单工单类型选择
      roomFormShow: false, // 表单所属房屋选择
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      orderSubmit: false, // 工单提交弹框
      form: {
        // 工单提交表单
        repairType: "",
        roomId: "",
        repairContent: "",
        resources: [],
      },
      areaData: [], // 所属房屋数据
      fieldNames: {
        text: "name",
        value: "id",
        children: "childList",
      },
      formText: {
        // 表单显示文本
        typeText: "请选择",
        roomText: "请选择",
        contentText: "",
      },
      rules: {
        repairType: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: "change",
          },
        ],
        roomId: [
          {
            required: true,
            message: "请选择所属房屋",
            trigger: "change",
          },
        ],
        repairContent: [
          {
            required: true,
            message: "请输入工单内容",
            trigger: "blur",
          },
        ],
      },
      fileList: [], // 上传图片时的图片列表
      progressData: {}, // 工单进度条数据
      companyId: "", // 公司ID
      isData: true,
      currentPage: 1,
      currentPageSize: 30,
      currentPermission: {}, // 权限信息
    };
  },
  created() {
    // let value = new Date();
    // let valueYear = value.getFullYear();
    // let valueMonth = value.getMonth() + 1;
    // if (valueMonth < 10) {
    //   valueMonth = "0" + valueMonth;
    // }
    // this.requestData.createDate = valueYear + "-" + valueMonth;
    this.companyId = this.$store.state.initialData.companyId;
    console.log(this.$store.state.initialData);
    this.currentPermission = this.$store.state.initialData.currentPermission
    this.getData();
    this.getAreaData();
    this.getProgressData();
  },
  methods: {
    pull(num) { // 上拉刷新
        console.log('pull回调List');
        this.gainMore()
        // setTimeout(() => {
        //   this.num = num;
        //   if (this.history_list.length >= this.pk_list_data.others_family_list.length) {
        //     console.log('完了');
        //     this.$refs.pull.$emit('loadOver') // 加载完毕
        //   } else {
        //     console.log(666)
        //     this.$refs.pull.$emit('loadEnd') // 加载完毕
        //   }

        // }, 2000)
      },
    showSubmit(){ // 显示提交工单弹窗
      this.orderSubmit = true
      for(let i in this.form){
        this.form[i] = ""
        if(i=='resources'){
          this.form[i] = []
        }
      }
      this.formText.typeText = "请选择"
      this.formText.roomText = "请选择"
      this.formText.contentText = ""
      this.fileList = []
    },
    gainMore(){ // 加载更多数据列表
      this.currentPage += 1
      this.getData()
    },
    getData() {
      // 获取列表数据
      let that = this;
      let data = {
        companyId: this.companyId,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        ...this.requestData,
      };
      orderList(data).then((res) => {
        console.log(res);
        let responseData = res.data;
        let responseDataArr = res.data.data.records
        if (responseData.code == 0) {
          // responseData.data.perRead = (
          //   (responseData.data.meterRead * 100) /
          //   responseData.data.total
          // ).toFixed(0);
          // responseData.data.perRead = parseInt(responseData.data.perRead);
          for (let i = 0; i < responseDataArr.length; i++) {
            if (responseDataArr[i].lastDate) {
              responseDataArr[i].lastDate = new Date(
                responseDataArr[i].lastDate
              ).toLocaleString("chinese", { hour12: false });
            }
            if (responseDataArr[i].repairType == 1) {
              responseDataArr[
                i
              ].img = require("../assets/propertyImg/updateIcon.png");
            } else {
              responseDataArr[
                i
              ].img = require("../assets/propertyImg/reportIcon.png");
            }
          }
        }
        if (responseDataArr.length == 0) {
            that.$refs.pull.$emit('loadOver') // 加载完毕，无数据了
            // that.$message.error("没有更多数据了");
          } else {
            that.$refs.pull.$emit('loadEnd') // 加载完毕，可能还有下一波数据
            for (let i = 0; i < responseDataArr.length; i++) {
              that.resdata.push(responseDataArr[i]);
            }
            that.isData = true;
          }
        that.dataObj = responseData.data;
      });
    },
    getProgressData(){ // 获取进度条数据
      let that = this;
      orderProgress(this.companyId).then((res) => {
        console.log(res);
        that.progressData = res.data.data;
        that.progressData.percent = parseInt(Math.ceil(that.progressData.finished/that.progressData.total))
      });
    },
    getAreaData() {
      // 获取区域数据(筛选所属房屋)
      let that = this;
      let requestData = {
        companyId: this.companyId,
      };
      areaList(requestData).then((res) => {
        console.log(res);
        that.areaData = res.data.data;
      });
    },
    formatter(type, val) {
      // 日期选择框格式
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    dateConfirm(value) {
      // 更改日期
      this.dateShow = false;
      let valueYear = value.getFullYear();
      let valueMonth = value.getMonth() + 1;
      let valueDay = value.getDate();
      if (valueMonth < 10) {
        valueMonth = "0" + valueMonth;
      }
      if (valueDay < 10) {
        valueDay = "0" + valueDay;
      }
      this.requestData.createDate = valueYear + "-" + valueMonth + '-' + valueDay;
      this.resdata = []
      this.getData();
    },
    onListFinish(value){ // 更改菜单所属房屋
      console.log(value);
      // this.selectRoomName = value.name;
      this.requestData.roomId = value.value;
      this.roomShow = false;
      this.resdata = []
      this.getData()
    },
    tableSelect(value) {
      // 更改工单类型
      // this.selectTableName = value.name;
      this.requestData.repairType = value.value;
      this.tableShow = false;
      this.resdata = []
      this.getData();
    },
    statusSelect(value) {
      // 更改工单状态
      // this.selectStatusName = value.name;
      this.requestData.repairStatus = value.value;
      this.statusShow = false;
      this.resdata = []
      this.getData();
    },
    typeFormSelect(value) {
      // 更改表单工单类型
      this.form.repairType = value.value;
      this.formText.typeText = value.name;
      this.$refs.ruleForm.clearValidate("repairType");
      this.typeFormShow = false;
    },
    onFinish(value) {
      // 更改表单所属房屋
      console.log(value)
      let that = this
      if(value.selectedOptions[value.selectedOptions.length-1].type!=1){
        this.roomFormShow = false;
        Notify({ type: 'warning', message: '请选择房屋' });
        return;
      } else {
        this.formText.roomText =
        value.selectedOptions[value.selectedOptions.length - 1].name;
        this.form.roomId = value.value;
        this.$refs.ruleForm.clearValidate("roomId");
        this.roomFormShow = false;
      }
    },
    confirmForm() {
      // 确认提交表单
      console.log(this.fileList);
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let imgNum = 0;
          for (let i = 0; i < this.fileList.length; i++) {
            let formData = new FormData();
            console.log(this.fileList[i].file);
            formData.append("file", this.fileList[i].file); // 文件对象
            imgUpload(formData).then((res) => {
              // 上传平面图
              console.log(res);
              if (res.data.code == 0) {
                that.form.resources.push(res.data.data[0]);
                imgNum++;
              } else {
                that.$message.error("上传失败,请稍后重试");
                return;
              }
            });
          }
          console.log(that.form.resources);
          console.log(imgNum);
          setTimeout(function() {
            if (imgNum == that.fileList.length) {
              let requestData = {
                companyId: that.companyId,
                ...that.form,
              };
              addOrder(requestData).then((res) => {
                console.log(res);
                if (res.data.code == 0) {
                  that.$message.success("提交成功");
                  that.getData();
                } else {
                  that.$message.error("提交失败,请稍后重试");
                }
              });
              that.orderSubmit = false;
            }
          }, 500);
        } else {
          console.log("表单数据不完整");
          return false;
        }
      });
    },
    backPage() {
      // 回退到首页
      this.$router.push("/property-index");
    },
    navigatePage(item) {
      // 跳转页面
      console.log(item);
      this.$router.push({
        name: "OrderDetail",
        params: {
          obj: item,
        },
      });
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  position: relative;
  padding-bottom: 19%;
  margin-bottom: 0.3rem;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 状态菜单筛选部分 */
.menu-select {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem 0;
}

.menu-select > div {
  display: flex;
  align-items: center;
}
.menu-select > div /deep/.anticon-down {
  margin-top: 2px;
}
.menu-select > div span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
  margin-right: 0.1rem;
}
.copy-process {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 95%;
  padding: 0.4rem 0;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0px 2px 8px 0px #ccd0d4;
  border-radius: 10px;
}

.copy-process /deep/.ant-progress-line {
  width: 5rem;
}

.copy-process > div {
  margin-top: 0.05rem;
}
.copy-process > div span:nth-child(1) {
  color: #1484ff;
}
.main-content /deep/.van-picker__toolbar {
  border-bottom: 1px solid #eeeeee;
}
/* 抄表内容部分 */
.list-content {
  padding: 0.3rem;
}
.list-content .content-all {
  background-color: white;
  padding: 0.3rem;
  border-radius: 8px;
}
.list-content .content-part {
  display: flex;
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 0.3rem;
  margin-bottom: 0.3rem;
}

.content-part img {
  width: 1.5rem;
  height: 1.3rem;
  margin-top: 0.1rem;
}

.content-part > div {
  display: flex;
  flex-direction: column;
  margin-left: 0.3rem;
  width: 100%;
}

.content-part > div > div {
  margin-bottom: 0.1rem;
  display: flex;
  align-items: center;
}

.content-part > div > div span:nth-child(1) {
  display: inline-block;
  width: 5rem;
  margin-right: 10%;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  display: inline-block;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-part > div > div span:nth-child(2) {
  width: 1.5rem;
  height: 0.5rem;
  text-align: center;
  line-height: 0.5rem;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background-color: #d5fccc;
  color: #46cc5e;
  border-radius: 2px;
}

.content-part > div > span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  margin-bottom: 0.1rem;
}
/* 提交工单部分 */
.contact-method {
  display: flex;
  background: #ffffff;
  align-items: center;
  margin-top: 0.3rem;
  justify-content: center;
  padding: 0.3rem 0.4rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-shadow: 0px -2px 4px 0px #EFEFEF;
}
/* 提交工单弹窗 */
.order-title {
  width: 100%;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  font-size: 0.45rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  border-bottom: 1px solid #f3f3f3;
}
.typeSelect {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
  margin-left: auto;
  justify-content: flex-end;
  margin-right: 0.4rem;
}
.order-form {
  padding-left: 0.4rem;
}
.order-form /deep/.ant-form-item-label {
  padding: 0px;
}
/* 确认/取消部分 */
.btn-method {
  display: flex;
  height: 1.5rem;
  background: #ffffff;
  align-items: center;
  margin-top: 0.1rem;
  justify-content: center;
  box-shadow: 0px -2px 4px 0px #efefef;
}
.btn-method /deep/.ant-btn {
  width: 39%;
  height: 1.1rem;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
/* 加载更多按钮样式 */
.loadMore {
  width: 50%;
  border-radius: 10px;
  margin: 0 auto;
  background-color: #1584ff;
  color: white;
  text-align: center;
  padding: 0.2rem 0;
  margin-top: 0.5rem;
}
</style>
